import { getAxiosInstance } from "../ApiConfig";

async function FetchUserDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/userProfileByUserId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllUsersList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAlluser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllLoginHistoryByUserId(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLoginHistoryByUserId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllLoginHistoryByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllLoginHistoryByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchUserByCompany(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllUserByCompany/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UserCreate(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/user`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchreportingRoleUsers() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/reportingRoleUsers`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findCompanyRoleUserByReporting(departmentData, company) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCompanyRoleUserByReporting/${departmentData}/${company}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getByUser() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getByUserProfile() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/userProfile`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getUserById(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/user/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteUser(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/user/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createUser(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/user`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateUser(payload, drawerId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/user/${drawerId}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateUserProfile(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateUserProfile`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function resetPassword(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/resetPassword`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    deleteUser,
    createUser,
    updateUser,
    getUserById,
    FetchUserDetails,
    FetchUserByCompany,
    UserCreate,
    FetchAllUsersList,
    FetchreportingRoleUsers,
    getByUser,
    getByUserProfile,
    findCompanyRoleUserByReporting,
    getAllLoginHistoryByUserId,
    updateUserProfile,
    getAllLoginHistoryByUser,
    resetPassword,
}